export default __webpack_public_path__ + "static/media/IconEventActive.d43adc64.svg";